import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {forkJoin, Observable, Observer, throwError} from 'rxjs';
import {User} from '../models/user';
import {OrganizationDataSource} from './OrganizationDataSource';
import {OrganizationAdminsDataModel} from '../models/organization-admins-data.model';
import {UserRegistration} from '../models/user.registration';
import {catchError, map} from 'rxjs/operators';
import {environment} from "../../environments/environment";
import {PaginatedResponse} from "../models/paginated-response";
import {AppRole} from "../models/app-role";
import {IdentityResult} from "./IdentityResult";

@Injectable()
export class UserDataSource {

  constructor(
    private http: HttpClient,
    private orgDataSource: OrganizationDataSource
  ) { }

  getAllOrgAdmins(): Observable<User[]> {
    return this.http.get<User[]>(environment.backendApi + 'api/User/GetOrganizationAdmins');
  }

  getOrgAdmins(organizationId: number): Observable<User[]> {
    return this.http.get<User[]>(environment.backendApi + 'api/User/GetOrganizationAdmins/' + organizationId);
  }

  getOrgAdminData(organizationId: number): Observable<OrganizationAdminsDataModel> {
    const admins = this.http.get<User[]>(environment.backendApi + 'api/User/GetOrganizationAdmins/' + organizationId);
    const organizationInfo = this.orgDataSource.getOrganization(organizationId);
    return new Observable((observer: Observer<OrganizationAdminsDataModel>) => {
      forkJoin([admins, organizationInfo])
        .subscribe(([a, o]) => {
          const model = new OrganizationAdminsDataModel();
          model.admins = a;
          model.organization = o;
          observer.next(model);
          observer.complete();
        });
    });
  }

  public createOrganizationManager(model: UserRegistration): Observable<any> {
    const body: string = JSON.stringify(model);

    // Sends an authenticated request.
    return this.http.post<Response>('/api/User/createOrganizationManager', body, {
      headers: new HttpHeaders().set('Content-Type', 'application/json')
    }).pipe(
      map((response: Response) => {
        return response;
      }),
      catchError((error: any) => {
        return throwError(error);
      }));
  }

  getAllRoles(): Observable<AppRole[]> {
    return this.http.get<AppRole[]>(environment.backendApi + 'api/Role/GetRoles')
  }

  getAllUsers(filter: string): Observable<PaginatedResponse<User>> {
    const options = {}
    if (filter && filter.length > 0) {
      options["params"] = { filter };
    }
    return this.http.get<PaginatedResponse<User>>(environment.backendApi + 'api/User/GetUsers', options);
  }

  updateUser(model: User, id: number) {
    const body: string = JSON.stringify(model);

    return this.http.put<IdentityResult>(environment.backendApi + 'api/User/' + id, body, {
      headers: new HttpHeaders().set('Content-Type', 'application/json')
    })
  }

  createUser(model: User) {
    const body: string = JSON.stringify(model);

    return this.http.post<IdentityResult>(environment.backendApi + 'api/User', body, {
      headers: new HttpHeaders().set('Content-Type', 'application/json')
    })
  }

  deleteUser(id: number) {
    return this.http.delete<IdentityResult>(environment.backendApi + 'api/User/' + id)
  }
}

